import downloadTrack from "../downloadTrack";

export default host => (voiceId) => downloadTrack(host, voiceId, 'voice')